import React, { useState, useEffect } from 'react';
import { Button, Input, notification, Select, Space, Table, Modal, Form, DatePicker } from 'antd';

import { ExportOutlined, FilterFilled, FilterOutlined, ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import "../Pages/CSS/Traitement.css";
import { TraitementService } from '../Services/TraitementService';
import { ExerciceDocService } from '../Services/ExerciceDocService';
import * as XLSX from 'xlsx';
import moment from 'moment';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
const DetailsActes = () => {


  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [selectedMonth, setSelectedMonth] = useState(
    (new Date().getMonth() + 1).toString()
  );
  const [filteredData, setFilteredData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [years, setYears] = useState([]);

  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [searchFields, setSearchFields] = useState({
    numdoc: '',
    typedoc: '',
    fournisseur: '',
    libacte: '',
    numfact: '',
    dateRange: null
  });
  const traitementsoinsService = new TraitementService();
  const exerciceDocService = new ExerciceDocService();


  useEffect(() => {
    const fetchData = async () => {
      try {
        const yearsData = await exerciceDocService.getFactureExercicesDoc();
        setYears([...yearsData].sort((a, b) => b - a));

      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData1 = async () => {
      if (selectedYear && selectedMonth && selectedMonth !== "14") {
        setLoading(true);
        try {
          const details = await traitementsoinsService.getDetailsActes(
            selectedYear,
            selectedMonth
          );
          setTableData(details);
          setFilteredData(details);
        } catch (error) {
          notification.error({
            message: "Erreur lors de la récupération des données",
          });
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData1();
  }, [selectedYear, selectedMonth]); // Ajoutez ces variables ici

  /* useEffect(() => {
    setFilteredData(data);
  }, [data]); */ // Met à jour `filteredData` à chaque changement de `data`



  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  /*   const handleSearch = (value) => {
      const filtered = data.filter(item =>
        Object.keys(item).some(key =>
          String(item[key]).toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilteredData(filtered);
    }; */

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
  };
  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    if (value !== "14") {
      // Si ce n'est pas "date à date", on vide la plage de dates
      setDateRange(null);
    }
  };

  /*   const handleDateRangeChange = (dates) => {
      if (dates && dates.length === 2) {
        const [start, end] = dates;
        const filtered = data.filter(item => {
          const itemDate = dayjs(item.datedoc, 'YYYY-MM-DD'); // Assurez-vous du format de `datedoc`
          return itemDate.isSameOrAfter(start, 'day') && itemDate.isSameOrBefore(end, 'day');
        });
        setFilteredData(filtered);
      } else {
        // Si aucune date n'est sélectionnée ou si l'utilisateur annule la sélection
        setFilteredData(data);
      }
    }; */
  const handleDateRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;

      // Mettre à jour l'état `dateRange` pour maintenir les dates sélectionnées
      setDateRange([start, end]);

      // Filtrer les données en fonction de la plage de dates sélectionnée
      const filtered = tableData.filter(item => {
        const itemDate = dayjs(item.datedoc, 'YYYY-MM-DD');
        return itemDate.isSameOrAfter(start, 'day') && itemDate.isSameOrBefore(end, 'day');
      });

      setFilteredData(filtered); // Mettre à jour les données filtrées
    } else {
      // Si aucune date n'est sélectionnée ou si l'utilisateur annule la sélection
      setDateRange(null); // Réinitialiser l'état de la plage de dates
      setFilteredData(tableData); // Remettre toutes les données si aucun filtre n'est appliqué
    }
  };

  const formatNumberWithSeparator = (number) => {
    // Convertit en nombre au cas où l'entrée n'est pas déjà un nombre
    const num = Number(number);
    return num.toLocaleString("fr-FR"); // Utilisez 'fr-FR' ou une autre locale appropriée
  };


  const monthOptions = [
    { value: "14", label: "date à date" },
    { value: "13", label: "Tous les mois" },
    { value: "1", label: "Janvier" },
    { value: "2", label: "Février" },
    { value: "3", label: "Mars" },
    { value: "4", label: "Avril" },
    { value: "5", label: "Mai" },
    { value: "6", label: "Juin" },
    { value: "7", label: "Juillet" },
    { value: "8", label: "Août" },
    { value: "9", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];







  const getColumnSearchProps = (dataIndex, placeholder) => {
    // Récupérer les valeurs uniques de la colonne spécifiée
    const uniqueValues = Array.from(new Set(tableData.map((item) => item[dataIndex])));

    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Rechercher ${placeholder || dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: 90 }}
            >
              Rechercher
            </Button>
            <Button
              onClick={() => clearFilters()}
              size="small"
              style={{ width: 90 }}
            >
              Réinitialiser
            </Button>
          </Space>
        </div>
      ),
      filterIcon: filtered => (
        <FilterFilled
          title="filtre"
          style={{
            fontSize: 12,
            color: '#ffff',
            paddingRight: 8
          }}
        />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
          : '',
      // Utiliser les valeurs uniques récupérées dans la colonne pour le tri ou autres usages
      uniqueValues
    };
  };

  const columns = [
    {
      title: 'Numéro Doc',
      dataIndex: 'numdoc',
      key: 'numdoc',
      align: "center",
      sorter: (a, b) => (a.numdoc || '').localeCompare(b.numdoc || ''),
      ...getColumnSearchProps('numdoc')
    },
    {
      title: 'Date Doc',
      dataIndex: 'datedoc',
      key: 'datedoc',
      align: "center",
      sorter: (a, b) => dayjs(a.datedoc).unix() - dayjs(b.datedoc).unix(),
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {record.datedoc ? dayjs(record.datedoc).format("DD/MM/YYYY") : 'N/A'}
        </div>
      )
    },
    {
      title: 'Type Doc',
      dataIndex: 'typedoc',
      key: 'typedoc',
      align: "center",
      ...getColumnSearchProps('typedoc'),
      sorter: (a, b) => (a.typedoc || '').localeCompare(b.typedoc || '')
    },
    {
      title: 'Code Prest',
      dataIndex: 'codeprest',
      key: 'codeprest',
      align: "center",
      ...getColumnSearchProps('codeprest'),

      sorter: (a, b) => (a.codeprest || '').localeCompare(b.codeprest || '')
    },
    {
      title: 'Code Acte',
      dataIndex: 'codeacte',
      key: 'codeacte',
      align: "center",
      ...getColumnSearchProps('codeacte'),
      sorter: (a, b) => (a.codeacte || '').localeCompare(b.codeacte || '')
    },
    {
      title: 'Libelle Acte',
      dataIndex: 'libacte',
      key: 'libacte',
      ...getColumnSearchProps('libacte'),
      sorter: (a, b) => (a.libacte || '').localeCompare(b.libacte || '')
    },
    {
      title: 'Numéro Fournisseur',
      dataIndex: 'codefourn',
      key: 'codefourn',
      align: "center",
      ...getColumnSearchProps('codefourn'),
      sorter: (a, b) => (a.numfourn || '').localeCompare(b.numfourn || '')
    },
    {
      title: 'Fournisseur',
      dataIndex: 'fournisseur',
      key: 'fournisseur',
      ...getColumnSearchProps('fournisseur'),
      sorter: (a, b) => (a.fournisseur || '').localeCompare(b.fournisseur || '')
    },
    {
      title: 'Num Facture',
      dataIndex: 'numfact',
      key: 'numfact',
      align: "center",
      ...getColumnSearchProps('numfact'),
      sorter: (a, b) => (a.numfact || '').localeCompare(b.numfact || '')
    },


    {
      title: 'Frais Réels',
      dataIndex: 'freel',
      key: 'freel',
      align: "right",
      ...getColumnSearchProps('freel'),
      sorter: (a, b) => (a.freel || 0) - (b.freel || 0),
      render: (text) => <strong>{formatNumberWithSeparator(text || 0)}</strong>
    },
    {
      title: 'QP IPM',
      dataIndex: 'qpipm',
      key: 'qpipm',
      align: "right",
      ...getColumnSearchProps('qpipm'),
      sorter: (a, b) => (a.qpipm || 0) - (b.qpipm || 0),
      render: (text) => <strong>{formatNumberWithSeparator(text || 0)}</strong>
    },
    {
      title: 'QP Part',
      dataIndex: 'qppart',
      key: 'qppart',
      align: "right",
      ...getColumnSearchProps('qppart'),
      sorter: (a, b) => (a.qppart || 0) - (b.qppart || 0),
      render: (text) => <strong>{formatNumberWithSeparator(text || 0)}</strong>
    },
    {
      title: 'QP Mutuelle',
      dataIndex: 'qpmut',
      key: 'qpmut',
      align: "right",
      ...getColumnSearchProps('qpmut'),
      sorter: (a, b) => (a.qpmut || 0) - (b.qpmut || 0),
      render: (text) => <strong>{formatNumberWithSeparator(text || 0)}</strong>
    },
    {
      title: 'Frais Exclus',
      dataIndex: 'fexclus',
      key: 'fexclus',
      align: "right",
      ...getColumnSearchProps('fexclus'),
      sorter: (a, b) => (a.fraisExclus || 0) - (b.fraisExclus || 0),
      render: (text) => <strong>{formatNumberWithSeparator(text || 0)}</strong>
    },



    {
      title: 'Ajustement',
      dataIndex: 'ajustmt',
      key: 'ajustmt',
      align: "center",
      ...getColumnSearchProps('ajustmt'),
      sorter: (a, b) => (a.ajustmt || 0) - (b.ajustmt || 0),
      render: (text) => <strong>{formatNumberWithSeparator(text || 0)}</strong>
    },
    {
      title: 'Quantité',
      dataIndex: 'qte',
      key: 'qte',
      align: "center",
      ...getColumnSearchProps('qte'),
      sorter: (a, b) => (a.qte || 0) - (b.qte || 0),
      render: (text) => text || 0
    },
    {
      title: 'Code Société',
      dataIndex: 'codesoc',
      key: 'codesoc',
      align: "center",
      ...getColumnSearchProps('codesoc'),
      sorter: (a, b) => (a.codesoc || '').localeCompare(b.codesoc || '')
    },
    {
      title: 'Nom Société',
      dataIndex: 'societe',
      key: 'societe',
      ...getColumnSearchProps('societe'),
      sorter: (a, b) => (a.societe || '').localeCompare(b.societe || '')
    },
    {
      title: 'Matricule',
      dataIndex: 'matricule',
      key: 'matricule',
      align: "center",
      ...getColumnSearchProps('matricule'),
      sorter: (a, b) => (a.matricule || '').localeCompare(b.matricule || '')
    },
    {
      title: 'Participant',
      dataIndex: 'participant',
      key: 'participant',
      ...getColumnSearchProps('participant'),
      sorter: (a, b) => (a.participant || '').localeCompare(b.participant || '')
    },
    {
      title: 'Type Bénéf',
      dataIndex: 'typebenef',
      key: 'typebenef',
      align: "center",
      ...getColumnSearchProps('typebenef'),
      sorter: (a, b) => (a.typeBenef || '').localeCompare(b.typeBenef || '')
    },
    {
      title: 'Matri Bénéf',
      dataIndex: 'matribenef',
      key: 'matribenef',
      align: "center",
      ...getColumnSearchProps('matribenef'),
      sorter: (a, b) => (a.matribenef || '').localeCompare(b.matribenef || '')
    }
  ];


  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convertit les données en feuille Excel
    const wb = XLSX.utils.book_new(); // Crée un nouveau classeur
    XLSX.utils.book_append_sheet(wb, ws, 'Détails Actes'); // Ajoute la feuille au classeur
    XLSX.writeFile(wb, 'details_actes.xlsx'); // Enregistre le fichier Excel
  };
  const handleResetFilters = () => {
    setDateRange(null); // Réinitialise la plage de dates
    setFilteredData(tableData); // Remet toutes les données dans la table
  };


  return (
    <div>
      <div style={{ marginBottom: 16, display: "flex", justifyContent: "space-between" }}>
        <Space>
          <Space wrap>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Exercice</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 100,
                  "--select-accent": "#1890ff",
                  "--select-accent-bg": "#e6f4ff",
                  "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {years.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Mois</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 150,
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                //onChange={setSelectedMonth}
                onChange={handleMonthChange}
                value={selectedMonth}
              >
                {monthOptions.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Space>
            {selectedMonth === "14" && (
              <Space direction="vertical" style={{ marginLeft: 12 }}>
                <label>Intervalle de dates</label>
                <RangePicker
                  onChange={handleDateRangeChange}
                  format="DD/MM/YYYY"
                  value={dateRange}
                />
              </Space>
            )}
            <Space style={{ marginTop: 25 }}>
              <Input
                className="search-input-highlight"
                placeholder="Rechercher..."
                allowClear
                prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                onChange={(e) => handleSearch(e.target.value)}
                /*   onPressEnter={(e) => handleSearch(e.target.value)} */
                style={{ width: 250 }}
              />
            </Space>
          </Space>

        </Space>
        <Space>
          <Button className='buttonExport' onClick={exportToExcel} style={{ marginTop: 30 }} icon={<ExportOutlined />}>Exporter</Button>
          <Button icon={<ReloadOutlined />} className='buttonRefresh' style={{ marginTop: 30 }} onClick={handleResetFilters}></Button>
        </Space>
      </div>
      <Table
        scroll={{
          x: true,
        }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header1-table"
        showSorterTooltip={false}
        bordered
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        rowKey="numdoc"

      />

    </div>
  );
};

export default DetailsActes;
